import React, { useEffect, useRef, useState } from 'react';

import AddIcon from '@material-ui/icons/Add';
import DoneIcon from '@material-ui/icons/Done';
import ExpandMore from '@material-ui/icons/ExpandMore';

import { Heading } from 'Components-redesign/Typography/Heading';
import { useI18n } from 'Hooks';

import {
  AddButtonWrapper,
  Bar,
  Circle,
  Icon,
  List,
  ListItem,
  OuterWrapper,
  Text,
  Wrapper,
} from './styles';

export type ListItemType = {
  id: string;
  name: string;
};

export interface Props {
  name: string;
  selected?: { id: string; name?: string } | undefined | null;
  list?: ListItemType[];
  handleChange: (name: string, item: { id: string; name?: string }) => void;
  placeholder?: string;
  addButton?: {
    text: string;
    handleClick: () => void;
  };
  noDeselect?: boolean;
  disabled?: boolean;
}

const Select: React.FC<Props> = ({
  name,
  selected = null,
  list = [],
  placeholder,
  handleChange,
  addButton,
  noDeselect,
  disabled,
}) => {
  const { t } = useI18n();
  const ref = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);
  const placeholderText = placeholder || t('General.Select');

  const onChange = (item: { id: string; name?: string }) => {
    if (selected?.id == item.id && !noDeselect) {
      handleChange(name, { id: '' });
    } else {
      handleChange(name, item);
    }
    setOpen(false);
  };

  const handleClick = () => {
    if (list.length || addButton) {
      setOpen(!open);
    }
  };

  const handleDocClick = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleDocClick);

    return () => {
      document.removeEventListener('click', handleDocClick);
    };
  }, []);

  const checkKeyEnter = (e) => e.key === 'Enter' || e.key == ' ';

  const selectedInList = list.find((item) => item.id == selected?.id);
  const selectedText = selectedInList ? selectedInList.name : selected?.name;

  return (
    <OuterWrapper ref={ref} disabled={disabled}>
      <Wrapper open={open}>
        <Bar
          onClick={handleClick}
          tabIndex={0}
          onKeyDown={(e) => checkKeyEnter(e) && handleClick()}>
          <Text active={Boolean(selectedText)}>
            <span>{selectedText ? selectedText : placeholderText}</span>
          </Text>
          {(list.length || addButton) && (
            <Icon open={open}>
              <ExpandMore htmlColor="#8b8f93" />
            </Icon>
          )}
        </Bar>
        {open && (
          <List open={open}>
            {list.map((item, i) => (
              <ListItem
                key={i}
                onClick={() => onChange(item)}
                tabIndex={0}
                onKeyDown={(e) => checkKeyEnter(e) && onChange(item)}>
                <span>{item.name}</span>
                <Circle selected={item.id == selected?.id}>
                  <DoneIcon htmlColor="#ffffff" />
                </Circle>
              </ListItem>
            ))}
            {addButton && (
              <AddButtonWrapper onClick={addButton.handleClick}>
                <Heading level={5} color="var(--colorUIBlue)" bottom={0}>
                  {addButton.text}
                </Heading>
                <AddIcon htmlColor="var(--colorUIBlue)" />
              </AddButtonWrapper>
            )}
          </List>
        )}
      </Wrapper>
    </OuterWrapper>
  );
};

export default Select;
